/* ==========================================================================
   OLV-GIFT-GUARD — Zeitraum-Pruefung fuer den Geschenk-Schutz am Express-Checkout
   ==========================================================================
   snippets/buy-buttons.liquid setzt data-olv-gift-guard="1" am Produktformular,
   sobald ein aktiver Geschenk-Slot fuer die Variante greift (Trigger-Variante
   bzw. Schwelle), und schreibt die Zeitfenster dieser Slots an <buy-buttons>
   (data-olv-gift-windows, Epoch-Sekunden, null = unbefristet).

   Dieses Script nimmt den Schutz nur zurueck ("0"), wenn KEIN Fenster gerade
   laeuft. Grundstellung ist "aus": ohne Serverzeit, bei unlesbarem Fenster oder
   wenn das Script gar nicht laeuft, bleibt PayPal ausgeblendet.

   Zeitquelle und Regel wie snippets/gift-watcher.liquid: Serverzeit aus dem
   Date-Header von /cart.js (nie gecacht), als Abstand zur Browseruhr in
   window.__olvSrvSkew; halboffenes Intervall [from, to). Liegt der Abstand vom
   Watcher schon vor, wird er mitbenutzt. An der naechsten Grenze startet ein
   Timer eine neue Pruefung (offene Seite um 09:00 / 23:59).

   Beim Variantenwechsel ersetzt Impact nur <buy-buttons>, nicht das Formular.
   Ein MutationObserver bewertet deshalb neu, sobald ein neues <buy-buttons>
   oder Formular im DOM landet (auch im Quick-Buy-Drawer). Der Callback laeuft
   als Microtask vor dem naechsten Paint, es blitzt also nichts auf.
   ========================================================================== */
(function () {
  if (window.__olvGiftGuard) return;
  window.__olvGiftGuard = 1;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var timer = null;
  var pending = null;

  function srvNow() {
    var k = window.__olvSrvSkew;
    return typeof k === 'number' ? Math.floor((Date.now() + k) / 1000) : null;
  }

  function ensureSkew() {
    if (typeof window.__olvSrvSkew === 'number') return Promise.resolve();
    if (pending) return pending;
    pending = fetch(ROOT + 'cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) {
        var d = Date.parse(r.headers.get('Date'));
        if (!isNaN(d)) window.__olvSrvSkew = d - Date.now();
      })
      .catch(function () {})
      .then(function () { pending = null; });
    return pending;
  }

  /* null = unlesbar (Schutz bleibt an), [] = kein Slot greift. */
  function windowsOf(form) {
    var bb = form.querySelector('buy-buttons[data-olv-gift-windows]');
    if (!bb) return [];
    try {
      var list = JSON.parse(bb.getAttribute('data-olv-gift-windows'));
      return Array.isArray(list) ? list : null;
    } catch (e) {
      return null;
    }
  }

  function evaluate() {
    var forms = document.querySelectorAll('form[data-olv-gift-guard]');
    if (!forms.length) return;
    var now = srvNow();
    var next = null;

    Array.prototype.forEach.call(forms, function (form) {
      var list = windowsOf(form);
      var hide;
      if (list === null) {
        hide = true;
      } else if (!list.length) {
        hide = false;
      } else if (now === null) {
        hide = true;
      } else {
        hide = false;
        list.forEach(function (w) {
          var from = w && w.from != null ? Number(w.from) : null;
          var to = w && w.to != null ? Number(w.to) : null;
          if ((from === null || now >= from) && (to === null || now < to)) hide = true;
          if (from !== null && from > now && (next === null || from < next)) next = from;
          if (to !== null && to > now && (next === null || to < next)) next = to;
        });
      }
      var value = hide ? '1' : '0';
      if (form.getAttribute('data-olv-gift-guard') !== value) form.setAttribute('data-olv-gift-guard', value);
    });

    if (timer) { clearTimeout(timer); timer = null; }
    if (next !== null && now !== null) {
      var ms = (next - now) * 1000 + 1500;
      if (ms < 2147000000) timer = setTimeout(run, ms);
    }
  }

  function run() {
    evaluate();
    ensureSkew().then(evaluate);
  }

  function relevant(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches('buy-buttons, form[data-olv-gift-guard]')) return true;
    return !!node.querySelector('buy-buttons, form[data-olv-gift-guard]');
  }

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (relevant(added[j])) { run(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Schlafender Tab / bfcache: Timer koennen verrutschen. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') run();
  });
  window.addEventListener('pageshow', run);

  run();
})();
